import { Api } from '$api';

export const sendRef = (ref: any) => {
  Api.post('/registration/ref', {
    ref: parseInt(ref, 16),
  }).catch((err) => console.log('err', err));
};
